class InteriorHero extends DrupalBehavior {

    onContent() {
      const component = this;
      
      // $(window).on('resize', function () {
      //   var position = $('.interior-wrap [data-paragraph-type="interior_hero_with_6_ctas"] h1').offset();
      //   $('.interior-wrap [data-paragraph-type="interior_hero_with_6_ctas"] .hero-cta').css('left', position.left + 100);
      // }).resize();

      enquire.register(this.settings.breakpoints['guthrie_theme_guthrie_theme.md_min'].query, {
        match: () => {

            var $ctaHeight = $('.interior-wrap .content-top  .hero-cta').outerHeight();
            var $findHero = $('.interior-wrap .content-top #block-hero');
            $('.site-wrap.interior-wrap main article.content').css('margin-top', $ctaHeight / 2 + 35);
            if ($findHero.length) {
              $('.site-wrap.interior-wrap main aside.sidebar').css('margin-top', 60);
            }

            var $findHasImage = $('.interior-wrap .content-top #block-hero .has-image');
            if ($findHasImage.length) {
              $('.site-wrap.interior-wrap .main .content').css('margin-top', 60);
            }

            var $ctaHero = $('.interior-wrap .content-top #block-hero .has-ctas');
            var $ctaCount = $('.interior-wrap .content-top  .hero-cta .link-list > a').length;
            if ($ctaCount === 6) {
              $ctaHero.css('height', 332);
            } else if ($ctaCount === 5) {
              $ctaHero.css('height', 306);
            } else if ($ctaCount === 4) {
              $ctaHero.css('height', 286);
            } else {
              // Use normal styling
            }

        },
      });
      enquire.register(this.settings.breakpoints['guthrie_theme_guthrie_theme.sm_max'].query, {
        match: () => {
          $('.site-wrap.interior-wrap main article.content').css('margin-top', 30);
          $('.interior-wrap .content-top #block-hero .has-ctas').css('height', 250);
        },
      });

    }
  
  }
  
  DrupalBehavior.register('guthrie_theme.components', 'interior_hero_with_6_ctas', InteriorHero);
  